<div class="row " style="height: 100%;">
<mat-card class="example-card col-12 box-shadow">
    <mat-card-header class="row">
      <mat-card-title class="col-12">Avec l'autopartage Clem'</mat-card-title>
      <mat-card-subtitle  class="col-12">Je roule dans des voitures propres, respectueuses de l’environnement.</mat-card-subtitle>

    </mat-card-header>
    <mat-card-content>
      <p class="col-12">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, sit amet erat. Duis semper.
      </p>
      <div class="col-12 icon-display ">
        <div class="row">
            <div class="col">
                <div class="row" >
                  <div class="col-12">
                      <div class="icon-bg">
                          <mat-icon style="height:100%; width:100%;" svgIcon="autopartage"></mat-icon>
                      </div> 
                  </div>
                  <p class="col-12">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </p>
                </div>
              </div>
              <div class="col">
                  <div class="row" >
                    <div class="col-12">
                        <div class="icon-bg">
                            <mat-icon style="height:100%; width:100%;" svgIcon="autopartage"></mat-icon>
                        </div> 
                    </div>
                    <p class="col-12">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      </p>
                  </div>
                </div>
                <div class="col">
                    <div class="row" >
                      <div class="col-12">
                          <div class="icon-bg">
                              <mat-icon style="height:100%; width:100%;" svgIcon="autopartage"></mat-icon>
                          </div> 
                      </div>
                      <p class="col-12">
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        </p>
                    </div>
                  </div>
        </div>
      </div>

    </mat-card-content>
  </mat-card>
</div>